import { Routes } from '../../router/routes';
import { ReactComponent as ProfileIcon } from '../../assets/images/icons/profile.svg';
import { ReactComponent as DocumentIcon } from '../../assets/images/icons/document.svg';
import { ReactComponent as DashboardIcon } from '../../assets/images/icons/dashboard.svg';
import { ReactComponent as ParsingIcon } from '../../assets/images/icons/parsing.svg';
import { ReactComponent as MailingIcon } from '../../assets/images/icons/mailing.svg';
import { ReactComponent as InvitingIcon } from '../../assets/images/icons/inviting.svg';
import { ReactComponent as BaseIcon } from '../../assets/images/icons/base.svg';
// import { ReactComponent as ReportIcon } from '../../assets/images/icons/report.svg';
// import { ReactComponent as FinanceIcon } from '../../assets/images/icons/finance.svg';
import { ReactComponent as TariffIcon } from '../../assets/images/icons/tariffs.svg';

import { ReactComponent as UsersIcon } from '../../assets/images/icons/users-icon.svg';
import { ReactComponent as BotIcon } from '../../assets/images/icons/bot-icon.svg';
import { ReactComponent as CoinsIcon } from '../../assets/images/icons/coins-icon.svg';
import { ReactComponent as FilterIcon } from '../../assets/images/icons/filter-icon.svg';
import { ReactElement } from 'react';

export enum MenuCategory {
  Profile = 'profile',
  Navbar = 'navbar',
}

export interface MenuItem {
  position: number;
  text: string;
  link: Routes;
  icon?: ReactElement;
  menuCategory: MenuCategory;
  disabled?: boolean;
}

export const NAV_ITEMS: MenuItem[] = [
  {
    position: 0,
    text: 'menu.profile',
    link: Routes.Profile,
    icon: <ProfileIcon />,
    menuCategory: MenuCategory.Profile,
  },
  // {
  //   position: 0,
  //   text: 'menu.cart',
  //   link: Routes.Cart,
  //   menuCategory: MenuCategory.Profile,
  // },
  {
    position: 1,
    text: 'menu.documents',
    link: Routes.Documents,
    icon: <DocumentIcon />,
    menuCategory: MenuCategory.Profile,
  },
];

export const BASE_MENU_ITEMS: MenuItem[] = [
  {
    position: 0,
    text: 'menu.dashboard',
    link: Routes.Dashboard,
    icon: <DashboardIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 1,
    text: 'menu.parsing',
    link: Routes.Parsers,
    icon: <ParsingIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 2,
    text: 'menu.filtering',
    link: Routes.Filtration,
    icon: <FilterIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 3,
    text: 'menu.targeting',
    link: Routes.Mailing,
    icon: <MailingIcon />,
    // link: Routes.UnavailableServicePage,
    menuCategory: MenuCategory.Navbar,
    // disabled: true,
  },
  {
    position: 4,
    text: 'menu.inviting',
    link: Routes.Inviting,
    icon: <InvitingIcon />,
    menuCategory: MenuCategory.Navbar,
    // disabled: true,
  },
  // {
  //   position: 5,
  //   text: 'menu.reports',
  //   link: Routes.Reports,
  //   icon: <ReportIcon />,
  //   menuCategory: MenuCategory.Navbar,
  //   disabled: true,
  // },
  // {
  //   position: 6,
  //   text: 'menu.finance',
  //   link: Routes.Finance,
  //   icon: <FinanceIcon />,
  //   menuCategory: MenuCategory.Navbar,
  //   disabled: true,
  // },
  {
    position: 5,
    text: 'menu.tariffs',
    link: Routes.Tariffs,
    icon: <TariffIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  // {
  //   position: 5,
  //   text: 'menu.bases',
  //   link: Routes.Base,
  //   icon: <BaseIcon />,
  //   menuCategory: MenuCategory.Navbar,
  //   disabled: false,
  // },
];

export const ADMIN_NAV_ITEMS: MenuItem[] = [
  {
    position: 0,
    text: 'menu.profile',
    link: Routes.AdminProfile,
    icon: <ProfileIcon />,
    menuCategory: MenuCategory.Profile,
  },
  {
    position: 1,
    text: 'menu.documents',
    link: Routes.AdminDocuments,
    icon: <DocumentIcon />,
    menuCategory: MenuCategory.Profile,
    disabled: true,
  },
];

export const ADMIN_ITEMS: MenuItem[] = [
  {
    position: 0,
    text: 'menu.users',
    link: Routes.AdminUsers,
    icon: <UsersIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 1,
    text: 'menu.bots',
    link: Routes.AdminBots,
    icon: <BotIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 2,
    text: 'menu.tariffs',
    link: Routes.AdminTariff,
    icon: <TariffIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 3,
    text: 'menu.finance',
    link: Routes.AdminFinance,
    icon: <CoinsIcon />,
    menuCategory: MenuCategory.Navbar,
  },
  {
    position: 4,
    text: 'menu.inviting',
    link: Routes.AdminInviting,
    icon: <InvitingIcon />,
    menuCategory: MenuCategory.Navbar,
    // disabled: true,
  },
  {
    position: 5,
    text: 'menu.bases',
    link: Routes.AdminBase,
    icon: <BaseIcon />,
    menuCategory: MenuCategory.Navbar,
    disabled: false,
  },
];

export const SUPERUSER_MENU_ITEMS: MenuItem[] = [
  // {
  //   position: 5,
  //   text: 'Базы',
  //   link: Routes.Base,
  //   icon: <BaseIcon />,
  //   menuCategory: MenuCategory.Navbar,
  // },
];

export const MENU_ITEMS = BASE_MENU_ITEMS;
